import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
// import { MDCTextField } from '@material/textfield';

/*import "~@material/textfield/mdc-text-field.scss";*/
import './DeleteAccountPage.css';

class DeleteAccountForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: '',
      value: '',
      title: '',
      pathRedirect : "",
      redirect: false,
    };
  }
  
  componentDidMount() {
    this.loadFbLoginApi();
    localStorage.removeItem('fb_purchase_token');
    localStorage.removeItem('bt_nonce');
      if(localStorage.getItem("fb_access_token")) {
          this.facebookLogin(localStorage.getItem("fb_access_token"));
      } else if (localStorage.getItem("google_access_token")) {
          this.googleLogin(localStorage.getItem("google_access_token"));
      }
      if(!localStorage.getItem("y_jwt_token")) {
          this.setState({pathRedirect : "/", redirect: true})
      }
      /*window.google.accounts.id.initialize({
          client_id: "189879900990-j48su5nkn32vslbc57fssmkmtsqjt7s3.apps.googleusercontent.com",
      });*/
  }

    facebookLogin = (token) => {
        fetch(process.env.REACT_APP_API_BASE_URL + '/authentication/login/facebook/code/' + token,
            {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }})
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.data && result.data.message && result.data.message === 'Invalid OAuth access token.') {
                        localStorage.removeItem('fb_access_token');
                        localStorage.removeItem('y_jwt_token');
                        this.setState({pathRedirect : "/", redirect: true})
                    } else if(result.status !== undefined) {
                        localStorage.removeItem('fb_access_token');
                        localStorage.removeItem('y_jwt_token');
                        this.setState({pathRedirect : "/", redirect: true})
                    } else {
                        localStorage.removeItem('google_access_token');
                        localStorage.setItem('fb_access_token', token);
                        localStorage.setItem('y_jwt_token', result.jwtToken);
                    }
                },
                (error) => {
                    localStorage.removeItem('fb_access_token');
                    console.log("error", error)
                    this.googleLogout();
                    localStorage.removeItem('y_jwt_token');
                    this.setState({ pathRedirect : "/", redirect: true})
                }
            )
    }

    googleLogin = (token) => {
        fetch(process.env.REACT_APP_API_BASE_URL + '/authentication/login/google/code/' + token,
            {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }})
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.data && result.data.message) {
                        this.googleLogout();
                        localStorage.removeItem('google_access_token');
                        localStorage.removeItem('y_jwt_token');
                        this.setState({pathRedirect : "/", redirect: true})
                    } else if(result.status !== undefined) {
                        this.googleLogout();
                        localStorage.removeItem('google_access_token');
                        localStorage.removeItem('y_jwt_token');
                        this.setState({pathRedirect : "/", redirect: true})
                    } else {
                        localStorage.removeItem('fb_access_token');
                        localStorage.setItem('google_access_token', token);
                        localStorage.setItem('y_jwt_token', result.jwtToken);
                    }
                },
                (error) => {
                    localStorage.removeItem('google_access_token');
                    console.log("error", error)
                    this.googleLogout();
                    localStorage.removeItem('y_jwt_token');
                    this.setState({pathRedirect : "/", redirect: true})
                }
            )
    }

  scrollToBottom = () => {
      document.querySelector(".yform").scrollIntoView({ behavior: 'auto' });
  }

  loadFbLoginApi() {
    window.fbAsyncInit = function() {
        window.FB.init({
            appId      : 548346835996683,
            cookie     : true,  // enable cookies to allow the server to access
            // the session
            xfbml      : true,  // parse social plugins on this page
            version    : 'v5.0' // use version 2.1
        });
        window.FB.AppEvents.logPageView();
    };
      // Load the SDK asynchronously
      (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk.js";
          fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
  }

    googleLogout = () => {
        if (localStorage.getItem('google_access_token')) {
            window.google.accounts.id.disableAutoSelect();
            localStorage.removeItem('google_access_token');
            /*window.gapi.auth.authorize(
                {
                    'client_id': '189879900990-j48su5nkn32vslbc57fssmkmtsqjt7s3.apps.googleusercontent.com',
                    'scope': 'profile email',
                    'immediate': false,
                    cookie_policy: 'single_host_origin',
                    response_type: localStorage.getItem('google_access_token')
                },
                function (authResult) {
                    window.gapi.auth.signOut();
                    localStorage.removeItem('google_access_token');
                }
            );*/
        }
    }

  setRedirect = () => {
    this.setState({redirect:true});
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={{
        pathname: this.state.pathRedirect,
        state: { data: this.state.yantraResult,
                  day: this.state.s_day,
                  month: this.state.s_month,
                  year: this.state.s_year
                 },
    }} />
    }
  }

    deleteMyAccount = () => {
        var jwt_token = localStorage.getItem('y_jwt_token')
        var url  = process.env.REACT_APP_API_BASE_URL + '/user/delete';
        var self = this;
        fetch(url, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : jwt_token
            }
        })
            .then(response => response.json())
            .then( (response) => {
                if (response && response.changed) {
                    localStorage.removeItem('fb_access_token');
                    this.googleLogout();
                    localStorage.removeItem('google_access_token');
                    localStorage.removeItem('y_jwt_token');
                    document.querySelector('#success_request').style.display = 'block';
                    setTimeout(self.redirectAfterDelete, 5000);
                } else {
                    // localStorage.removeItem('fb_access_token');
                    // localStorage.removeItem('google_access_token');
                    // this.googleLogout();
                    // localStorage.removeItem('y_jwt_token');
                    // this.setState({yantraResult: response, pathRedirect: "/", redirect: true});
                    document.querySelector('#invalid_request').style.display = 'block';
                    document.querySelector('#invalid_request').innerHTML = '* ' + response.message;
                }
            });
    }

    redirectAfterDelete = () => {
        this.setState({pathRedirect: "/", redirect: true});
    }

  render() {
    return (
            <div className="yform">
                <div className="ytitle">
                    <p>Delete My Account</p>
                </div>
                <div>
                    <p>If you are sure you want yo delete your account, press the bellow button. You will be redirected to login page.</p>
                </div>
                {this.renderRedirect()}
                <div className='btn-group'>
                    <button id='uncover-yantra' className='submit-btn yantra' type='submit' onClick={this.deleteMyAccount}>DELETE MY ACCOUNT</button>
                </div>
                <div id="invalid_request">* Invalid request</div>
                <div id="success_request">* Successfully deleted your account</div>
                <div id="fb-root"></div>
            </div>
    )
  }
}

export default DeleteAccountForm;



// WEBPACK FOOTER //
// ./src/components/DeleteAccountPage/DeleteAccountForm.js